import * as React from "react";
import { AlertCircle, CheckCircle, Info, AlertTriangle } from "lucide-react";
import { cn } from "../../lib/utils";

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "error" | "success" | "info" | "warning";
}

const alertVariants = {
  error: {
    container: "bg-red-50 border-red-200 text-red-800",
    icon: <AlertCircle className="size-5 text-red-600" />,
  },
  success: {
    container: "bg-green-50 border-green-200 text-green-800",
    icon: <CheckCircle className="size-5 text-green-600" />,
  },
  info: {
    container: "bg-blue-50 border-blue-200 text-blue-800",
    icon: <Info className="size-5 text-blue-600" />,
  },
  warning: {
    container: "bg-yellow-50 border-yellow-200 text-yellow-800",
    icon: <AlertTriangle className="size-5 text-yellow-600" />,
  },
};

export function Alert({ variant = "info", className, children, ...props }: AlertProps) {
  const styles = alertVariants[variant];

  return (
    <div
      className={cn(
        "rounded-lg border p-4 flex items-start gap-3 my-2.5",
        styles.container,
        className
      )}
      {...props}
    >
      <div className="mt-0.5 shrink-0">{styles.icon}</div>
      <div className="flex-1">{children}</div>
    </div>
  );
}